import { render, staticRenderFns } from "./dormitory.vue?vue&type=template&id=8e51f6de&scoped=true"
import script from "./dormitory.vue?vue&type=script&lang=js"
export * from "./dormitory.vue?vue&type=script&lang=js"
import style0 from "./dormitory.vue?vue&type=style&index=0&id=8e51f6de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e51f6de",
  null
  
)

export default component.exports